// extracted by mini-css-extract-plugin
export default {"cls1":"Sze9i2y9L3j0bbk3NPMZ","cls2":"JumH7qG3UWasNQvj5JvZ Sze9i2y9L3j0bbk3NPMZ"};